import React, { useContext } from 'react';

import { StaticContext } from '@sm/webassets';
import { Button, Typography } from '@sm/wds-react';

import './jumbo-header.scss';

const JumboHeader = () => {
  const { user, HEADER_EXP: { isModernTreatment = false } = {} } = useContext(StaticContext);
  const shouldShowNewHeader = user.isAuthenticated && isModernTreatment;
  return (
    <div
      data-testid="JumboHeader__AppsDirectory"
      className={`${
        shouldShowNewHeader ? 'sm-jumbo-header--modern' : ''
      } sm-jumbo-header wds-flex wds-flex--y wds-flex--y-center wds-p-l-5 wds-p-r-5`}
    >
      <Typography variant="hero1" component="h1" color="light" className="sm-jumbo-header__title">
        We&apos;re better together
      </Typography>
      <Typography variant="cardTitle" component="div" color="light" className="sm-jumbo-header__subtitle">
        Connect SurveyMonkey with the apps you use daily—gather holistic feedback from the right audience at the right
        time. right place, and take insights-driven actions fast.
      </Typography>
      {!user.isAuthenticated && (
        <Button color="upgrade" href="/user/sign-up">
          Sign up now
        </Button>
      )}
    </div>
  );
};

export default JumboHeader;
